import PropTypes from 'prop-types';

import latlng from './latlng';

export default PropTypes.arrayOf(latlng);


// WEBPACK FOOTER //
// ../node_modules/react-leaflet/es/propTypes/latlngList.js